/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Patchy_Round_Cuckoo_StopInputs */

const es_patchy_round_cuckoo_stop = /** @type {(inputs: Patchy_Round_Cuckoo_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro de ayuda`)
};

const gl_patchy_round_cuckoo_stop = /** @type {(inputs: Patchy_Round_Cuckoo_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro de axuda`)
};

const en_patchy_round_cuckoo_stop = /** @type {(inputs: Patchy_Round_Cuckoo_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Help Center`)
};

/**
* | output |
* | --- |
* | "Help Center" |
*
* @param {Patchy_Round_Cuckoo_StopInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const patchy_round_cuckoo_stop = /** @type {((inputs?: Patchy_Round_Cuckoo_StopInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Patchy_Round_Cuckoo_StopInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_patchy_round_cuckoo_stop(inputs)
	if (locale === "en") return en_patchy_round_cuckoo_stop(inputs)
	return es_patchy_round_cuckoo_stop(inputs)
});